import { TWindow } from 'shared/types'

import { REGEXP } from 'shared/consts/regExp'

import { EmbedUrl } from './EmberUrl'

const reloadEmbeds = (): void => {
  const Window: TWindow = window

  try {
    if (Window['instgrm']) {
      Window['instgrm'].Embeds.process()
    }
    if (Window['twttr']) {
      Window['twttr'].widgets.load()
    }
  } catch (err) {
    console.error('Failed to reload embed', err)
  }
}

export const loadEmbedScript = (src: string): Promise<any> => {
  const loadedScriptSources: string[] = []
  const script = document.createElement('script')

  if (!src) {
    return Promise.resolve()
  }

  if (loadedScriptSources.includes(src)) {
    return Promise.resolve().then(reloadEmbeds)
  }

  script.src = src
  document.head.appendChild(script)
  loadedScriptSources.push(src)

  return new Promise((resolve) => {
    script.onload = resolve
  }).then(reloadEmbeds)
}

export const embedScriptSrc = (element: HTMLElement): string => {
  const script: HTMLScriptElement | null = element.querySelector('script[src]')

  return script ? script.src : ''
}

export function embedCode(value: string) {
  if (!value.match(REGEXP.HTTPS) && !value.match(REGEXP.TIKTOK_CODE_EMBEDED)) return value

  if (value.match(REGEXP.TIKTOK_CODE_EMBEDED)) {
    const result = value.match(REGEXP.TIKTOK_CODE_LINK)

    return result?.[1] ? new EmbedUrl(result?.[1]).toCode() : value
  }

  const url = new EmbedUrl(value)

  return url.toCode()
}
